export const getAbsolute = (input: string) : string => {
    const dev = process.env.NODE_ENV !== 'production';

    const url = dev ? "http://localhost:3000" : "https://ca9.io"
    return `${url}${input}`
}